import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		card: {
			marginBottom: theme.spacing(2)
		},
		avatar: {
			backgroundColor: theme.palette.primary.main,
			height: 30,
			width: 30
		},
		actionContainer: {
			gap: theme.spacing(1)
		},
		infoSection: {
			marginBottom: theme.spacing(3)
		},
		sectionTitle: {
			fontWeight: 600
		}
	} satisfies Record<string, CSSObject>;
};